import { render, staticRenderFns } from "./auth-bind.vue?vue&type=template&id=644c3798&scoped=true"
import script from "./auth-bind.vue?vue&type=script&lang=js"
export * from "./auth-bind.vue?vue&type=script&lang=js"
import style0 from "./auth-bind.vue?vue&type=style&index=0&id=644c3798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644c3798",
  null
  
)

export default component.exports